import * as React from 'react';

export const CrossMarkSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.333" height="21.328" viewBox="0 0 21.333 21.328"><path d="M24.48,21.953,32.1,14.333a1.785,1.785,0,1,0-2.525-2.525l-7.619,7.619-7.619-7.619a1.785,1.785,0,1,0-2.525,2.525l7.619,7.619L11.81,29.572A1.785,1.785,0,1,0,14.335,32.1l7.619-7.619L29.574,32.1A1.785,1.785,0,0,0,32.1,29.572Z" transform="translate(-11.285 -11.289)" fill="#fff"/></svg>
  );
};
